import { environment } from '@env/environment';
import { formatter } from '../utils/url-formatter';

// Base URLs
export const BASE = environment.haulmatic.baseUrl;
export const ZUUL = environment.haulmatic.apiGateway;

// GraphQL Endpoints
export const GRAPHQL = `${ZUUL}/api/graphql`;
export const FILE_CONVERTER = `${ZUUL}/api/file-converter`;
export const FILE_UPLOAD = `${BASE}/api/file-handler/v1/files`;
export const FILE_UPLOAD_V2 = `${BASE}/api/file-handler/v2/files`;
export const FILE_HANDLER_V1_LLM_SETTINGS = `${BASE}/api/file-handler/v1/llm-settings`;
export const CORTEX_CHAT = `${BASE}/api/cortex/chat`;
// Authentication and Organization Endpoints
const AUTH = `${BASE}/auth`;
//const AUTH = `http://localhost:8081/auth`;

const FILE_PARSER = `${BASE}/api/file-parser`;
const FILE_HANDLER = `${BASE}/api/file-handler`;

// API Endpoints
export const API = {
  auth: {
    getToken: `${AUTH}/v2/users/login`,
    refreshToken: `${AUTH}/v2/users/refresh`,
    getUserByUserId: formatter(`${AUTH}/identity/{0}`),
    getTenants: `${AUTH}/tenant-details`,
    resetPasswordInit: `${AUTH}/users/reset-password/init`,
    resetPassword: `${AUTH}/users/reset-password/reset`,
    logout: `${AUTH}/logout`,
    verifyControlTowerOtp: `${AUTH}/users/verify-control-tower-otp`,
    verifyMfaLogin: `${AUTH}/users/verify-mfa-login`,
    sendLoginMfaOtp: `${AUTH}/users/send-login-mfa-otp`,
    completeMfaSetupLogin: `${AUTH}/users/complete-mfa-setup-login`,
  },
  fileParser: {
    processBulkOrders: `${FILE_PARSER}/process-file/process-bulk-orders`,
  },
  fileHandler: {
    processBulkOrders: `${FILE_HANDLER}/parsing/bulk-orders`,
  },
};
